import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AntiCacheInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('/i18n')) {
      request = request.clone({
        setHeaders: {
          'Cache-Control': 'no-cache',
        },
      });
    }
    return next.handle(request);
  }
}
